import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { UserService } from '@forwardflow/services/UserService'

import useSWR from 'swr'

export const useGetUserCalenderInfo = (shouldFetch: boolean) => {
   const response = useSWR(
      shouldFetch ? [QUERY_KEYS.USER_CALENDAR_INFO] : null,
      () => UserService.getUserCalenderInfo(),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate(),
   }
}
